import { jsxs as o, jsx as C } from "react/jsx-runtime";
import { getIconStyles as r } from "../styles.js";
const n = (l) => /* @__PURE__ */ o(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r(l),
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M12 19.125C11.9005 19.125 11.8052 19.0855 11.7348 19.0152C11.6645 18.9448 11.625 18.8495 11.625 18.75C11.625 18.6505 11.6645 18.5552 11.7348 18.4848C11.7685 18.4511 11.808 18.4245 11.8508 18.4059C11.8978 18.3854 11.949 18.3744 12.0013 18.3744V17.6244C11.7029 17.6244 11.4168 17.743 11.2058 17.9539C10.9948 18.1649 10.8763 18.4511 10.8763 18.7494C10.8763 19.0478 10.9948 19.3339 11.2058 19.5449C11.4168 19.7559 11.7029 19.8744 12.0013 19.8744V19.1244L12 19.125Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M12.3763 18.7494C12.3763 18.8489 12.3368 18.9443 12.2665 19.0146C12.2328 19.0483 12.1934 19.0749 12.1505 19.0935C12.1038 19.1137 12.0531 19.1244 12.0013 19.1244V19.8744C12.2997 19.8744 12.5858 19.7559 12.7968 19.5449C13.0078 19.3339 13.1263 19.0478 13.1263 18.7494C13.1263 18.4511 13.0078 18.1649 12.7968 17.9539C12.5858 17.743 12.2997 17.6244 12.0013 17.6244V18.3744C12.1008 18.3744 12.1961 18.4139 12.2665 18.4843C12.3368 18.5546 12.3763 18.65 12.3763 18.7494Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 0C10.5342 0 9.18831 0.62938 8.02289 1.57888C6.8582 2.52777 5.83497 3.82599 4.99033 5.25407C3.30883 8.0971 2.25 11.6027 2.25 14.25C2.25 16.8359 3.27723 19.3158 5.10571 21.1443C6.93419 22.9728 9.41414 24 12 24C14.5859 24 17.0658 22.9728 18.8943 21.1443C20.7228 19.3158 21.75 16.8359 21.75 14.25C21.75 11.6027 20.6912 8.0971 19.0097 5.25407C18.165 3.82599 17.1418 2.52777 15.9771 1.57888C14.8117 0.62938 13.4658 0 12 0ZM6.28142 6.01768C4.70567 8.6819 3.75 11.9263 3.75 14.25C3.75 16.438 4.61919 18.5365 6.16637 20.0836C7.71354 21.6308 9.81196 22.5 12 22.5C14.188 22.5 16.2865 21.6308 17.8336 20.0836C19.3808 18.5365 20.25 16.438 20.25 14.25C20.25 11.9263 19.2943 8.6819 17.7186 6.01768C16.9346 4.69214 16.0185 3.54741 15.0297 2.74178C14.0416 1.93674 13.0197 1.5 12 1.5C10.9803 1.5 9.95844 1.93674 8.97033 2.74178C7.98149 3.54741 7.06541 4.69214 6.28142 6.01768Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.5 6C8.03587 6 7.59075 6.18437 7.26256 6.51256C6.93437 6.84075 6.75 7.28587 6.75 7.75V13.25C6.75 13.7141 6.93437 14.1592 7.26256 14.4874C7.59075 14.8156 8.03587 15 8.5 15H15.5C15.9641 15 16.4092 14.8156 16.7374 14.4874C17.0656 14.1592 17.25 13.7141 17.25 13.25V7.75C17.25 7.28587 17.0656 6.84075 16.7374 6.51256C16.4092 6.18437 15.9641 6 15.5 6H8.5ZM8.5 7.5C8.4337 7.5 8.37011 7.52634 8.32322 7.57322C8.27634 7.62011 8.25 7.6837 8.25 7.75V13.25C8.25 13.3163 8.27634 13.3799 8.32322 13.4268C8.37011 13.4737 8.4337 13.5 8.5 13.5H15.5C15.5663 13.5 15.6299 13.4737 15.6768 13.4268C15.7237 13.3799 15.75 13.3163 15.75 13.25V7.75C15.75 7.68369 15.7237 7.62011 15.6768 7.57322C15.6299 7.52634 15.5663 7.5 15.5 7.5H8.5Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M7.76517 18.2652C7.69484 18.3355 7.59945 18.375 7.5 18.375V19.125C7.79837 19.125 8.08452 19.0065 8.2955 18.7955C8.50647 18.5845 8.625 18.2984 8.625 18C8.625 17.7016 8.50647 17.4155 8.2955 17.2045C8.08452 16.9935 7.79837 16.875 7.5 16.875V17.625C7.59945 17.625 7.69484 17.6645 7.76517 17.7348C7.83549 17.8052 7.875 17.9005 7.875 18C7.875 18.0995 7.83549 18.1948 7.76517 18.2652Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M7.5 17.625V16.875C7.20163 16.875 6.91548 16.9935 6.7045 17.2045C6.49353 17.4155 6.375 17.7016 6.375 18C6.375 18.2984 6.49353 18.5845 6.7045 18.7955C6.91548 19.0065 7.20163 19.125 7.5 19.125V18.375C7.40054 18.375 7.30516 18.3355 7.23483 18.2652C7.16451 18.1948 7.125 18.0995 7.125 18C7.125 17.9005 7.16451 17.8052 7.23483 17.7348C7.30516 17.6645 7.40054 17.625 7.5 17.625Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M16.5 17.625V16.875C16.2016 16.875 15.9155 16.9935 15.7045 17.2045C15.4935 17.4155 15.375 17.7016 15.375 18C15.375 18.2984 15.4935 18.5845 15.7045 18.7955C15.9155 19.0065 16.2016 19.125 16.5 19.125V18.375C16.4005 18.375 16.3052 18.3355 16.2348 18.2652C16.1645 18.1948 16.125 18.0995 16.125 18C16.125 17.9005 16.1645 17.8052 16.2348 17.7348C16.3052 17.6645 16.4005 17.625 16.5 17.625Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M16.7652 18.2652C16.6948 18.3355 16.5995 18.375 16.5 18.375V19.125C16.7984 19.125 17.0845 19.0065 17.2955 18.7955C17.5065 18.5845 17.625 18.2984 17.625 18C17.625 17.7016 17.5065 17.4155 17.2955 17.2045C17.0845 16.9935 16.7984 16.875 16.5 16.875V17.625C16.5995 17.625 16.6948 17.6645 16.7652 17.7348C16.8355 17.8052 16.875 17.9005 16.875 18C16.875 18.0995 16.8355 18.1948 16.7652 18.2652Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  n as DevToolIcon
};
//# sourceMappingURL=DevToolIcon.js.map
